import { useQuery } from '@tanstack/react-query';
import { authFetch } from '../utils/authFetch';
import { API_URL } from '../config/api';

export interface PlaidAccount {
  id: number;
  account_id: string;
  name: string;
  official_name: string | null;
  mask: string | null;
  type: string;
  subtype: string | null;
  holder_category: string | null;
  balances_available: number | null;
  balances_current: number | null;
  balances_limit: number | null;
  balances_iso_currency_code: string | null;
  balances_unofficial_currency_code: string | null;
}

export function useListPlaidAccounts() {
  return useQuery<PlaidAccount[]>({
    queryKey: ['plaidAccounts'],
    queryFn: async () => {
      const response = await authFetch(`${API_URL}/integrations/plaid/accounts`);
      return response.json();
    },
  });
} 